import Main from "./Template";
import React,{useEffect,useState} from 'react';
function Quan(props) {
    const [userInfo, setUserInfo] = useState ({});
    // 在这里整理数据

    // 获取用户的评论信息

    // 获取用户的点赞信息
   // console.log (props,"圈子信息")
    useEffect (() => {
        getUserInfo()
    },  []);

    let getUserInfo = () => {
        if (props.item && props?.item['userinfo']) {
            setUserInfo(props.item['userinfo'])
        }else{
            setUserInfo(props.item.useInfo)
        }
    }

    return<Main {...props.item} useInfo={userInfo} commentInfo={props.item.commentInfo} dataInfo={props.item.dataInfo} likeInfo={props.item.likeInfo} />
}

export default Quan
